import { i18nLike } from "#web/services/i18nLike";
import { useAppBridge } from "@shopify/app-bridge-react";
import { Badge, BlockStack, Box, Button, Card, Grid, InlineStack, Text } from "@shopify/polaris";

import { FeedbackModalId } from "./FeedbackModal";

const en = {
  buttonLabel: "Got a feature request?",
  highlightedItem: {
    badge: "🎁 Coming in June",
    description: "Get notifications right into your Slack channel",
    title: "Slack integration",
  },
  improvement: "🛠 Improvement",
  items: [
    {
      date: "May 1, 2025",
      description: "Gain insights into how customers are using coupon extensions",
      tag: "new",
      title: "Extension insights & attribution",
    },
    {
      date: "April 16, 2025",
      description: "Track the usage of discount codes before and after leaks occur",
      tag: "new",
      title: "Discount code usage tracking",
    },
    {
      date: "March 29, 2025",
      description: "Improved monitoring and detection of browser extensions",
      tag: "improvement",
      title: "Improved extension blocking",
    },
  ],
  new: "🎉 New",
  subtitle: "See the latest updates and improvements to the app.",
  title: "What's new? 🎉",
};

export const ChangelogCard = () => {
  const t = i18nLike(en);
  const shopify = useAppBridge();

  return (
    <Card padding="500">
      <BlockStack gap="400">
        <InlineStack gap="300">
          <BlockStack gap="100">
            <Text as="h2" variant="headingMd">
              {t("title")}
            </Text>
            <InlineStack gap="100">
              <Text as="p" variant="bodyMd">
                {t("subtitle")}
              </Text>
              <Button onClick={() => shopify.modal.show(FeedbackModalId)} variant="plain">
                {t("buttonLabel")}
              </Button>
            </InlineStack>
          </BlockStack>
        </InlineStack>

        <Box background="bg-surface-secondary" borderRadius="200" padding="400">
          <BlockStack gap="150">
            <Box>
              <Badge size="large" tone="magic">
                {t("highlightedItem.badge")}
              </Badge>
            </Box>
            <BlockStack gap="100">
              <Text as="span" variant="headingSm">
                {t("highlightedItem.title")}
              </Text>
              <Text as="p" fontWeight="regular" tone="subdued" variant="bodyMd">
                {t("highlightedItem.description")}
              </Text>
            </BlockStack>
          </BlockStack>
        </Box>
        <Grid columns={{ xs: 3 }}>
          {en.items.map((item, index) => (
            <Grid.Cell columnSpan={{ xs: 4 }} key={index}>
              <Box background="bg-surface-secondary" borderRadius="200" minHeight="100" padding="400">
                <BlockStack gap="300">
                  <InlineStack align="space-between" blockAlign="center" gap="300">
                    <Badge size="large" tone={item.tag === "new" ? "warning" : "info"}>
                      {item.tag === "new" ? t("new") : t("improvement")}
                    </Badge>
                    <Text as="p" fontWeight="regular" tone="subdued" variant="bodySm">
                      {item.date}
                    </Text>
                  </InlineStack>

                  <BlockStack gap="150">
                    <Text as="span" variant="headingSm">
                      {item.title}
                    </Text>
                    <Text as="p" fontWeight="regular" tone="subdued" variant="bodyMd">
                      {item.description}
                    </Text>
                  </BlockStack>
                </BlockStack>
              </Box>
            </Grid.Cell>
          ))}
        </Grid>
      </BlockStack>
    </Card>
  );
};
